import React, { useEffect, useReducer, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import { CallWithAuth } from '../../../actions/apiAction';
import { CANCEL_SUBSCRIPTION_BY_ID, CHANGE_PAYMENT_METHOD_BY_ID, GET_INVOICES_BY_SUBSCRIPTION, GET_SUBSCRIBED_CREATOR, GET_SUBSCRIBED_CREATOR_BY_ID, RESUME_SUBSCRIPTION_BY_ID } from '../../../utils/apiUrl';
import Reducer from '../../../services/Reducer';
import moment from 'moment';
import PageLoader from '../../../components/PageLoader';
import toast from 'react-hot-toast';

const initState = {
    creatorData: '',
    loading: true,
    inVoiceList: '',
    inVoiceLoading: false,
    updatePaymentLoading: false,
    buttonLoading: false
};
export default function BillingHistory() {
    const [state, dispatch] = useReducer(Reducer, initState);
    const navigator = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const creatorId = query.get('creator_id');
    const [limit, setLimit] = useState(10);
    const getSubscriptionData = async () => {
        // dispatch({ type: "SETDATA", payload: { name: "loading", value: true } });

        let responce = await CallWithAuth("GET", GET_SUBSCRIBED_CREATOR_BY_ID(creatorId));
        if (responce.data) {
            getInvoiceList(responce?.data?.subscription_id);
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "creatorData", value: responce?.data } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "creatorData", value: null } });

        }
        dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
    };
    const getInvoiceList = async (subscription_id) => {
        dispatch({ type: "SETDATA", payload: { name: "inVoiceLoading", value: true } });

        let responce = await CallWithAuth("GET", GET_INVOICES_BY_SUBSCRIPTION(subscription_id, limit));
        if (responce.data) {
            dispatch({ type: "SETDATA", payload: { name: "inVoiceLoading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "inVoiceList", value: responce?.data?.invoices } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "inVoiceLoading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "inVoiceList", value: [] } });

        }
        dispatch({ type: "SETDATA", payload: { name: "inVoiceLoading", value: false } });
    };

    const handleChangePaymentMethod = async (id) => {
        dispatch({ type: "SETDATA", payload: { name: "updatePaymentLoading", value: true } });
        let responce = await CallWithAuth("POST", CHANGE_PAYMENT_METHOD_BY_ID(id));
        if (responce.data) {
            window.location.href = responce?.data?.url
        }
    }
    const handleCancelPlan = async (id) => {
        dispatch({ type: "SETDATA", payload: { name: "buttonLoading", value: true } });
        let responce = await CallWithAuth("POST", CANCEL_SUBSCRIPTION_BY_ID(id));
        if (responce.data) {
            toast.success('Plan Cancelled Successfully')
            dispatch({ type: "SETDATA", payload: { name: "buttonLoading", value: false } });
            getSubscriptionData();

        }
    }
    const handleResumePlan = async (id) => {
        dispatch({ type: "SETDATA", payload: { name: "buttonLoading", value: true } });
        let responce = await CallWithAuth("POST", RESUME_SUBSCRIPTION_BY_ID(id));
        if (responce.data) {
            toast.success('Plan Resumed Successfully')
            dispatch({ type: "SETDATA", payload: { name: "buttonLoading", value: false } });
            getSubscriptionData();
        }
    }

    const handleOpenPdf = (url) => {
        window.location.href = url;
    }
    useEffect(() => {
        getSubscriptionData();
    }, []);
    return (
        <>
            <Helmet>
                <title>Billing History</title>
            </Helmet>
            {/* start: billing-history page */}
            <div className="min-h-screen gradient-bg-1 p-6">

                <div className="flex items-center gap-4 mb-8">
                    <button className="text-foreground/70 hover:text-foreground transition-colors"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-xl font-bold text-foreground">
                        Billing &amp; Payments
                    </h1>
                </div>
                {
                    (state?.loading) ?
                        <PageLoader />
                        :
                        <div className="max-w-md mx-auto" style={{ opacity: 1, transform: "none" }}>
                            <div
                                className="bg-gradient-to-br from-primary/20 via-card to-accent/20 rounded-2xl p-6 border-2 border-primary shadow-lg mb-6"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <div className="flex items-center gap-2 mb-3">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-crown w-5 h-5 text-primary"
                                    >
                                        <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z" />
                                        <path d="M5 21h14" />
                                    </svg>
                                    <span className="font-bold text-foreground">{state?.creatorData?.plan_name} Plan</span>
                                </div>
                                <div className="flex items-baseline gap-2 mb-2">
                                    <span className="text-3xl font-bold text-primary">${state?.creatorData?.price}</span>
                                    <span className="text-muted-foreground">/{state?.creatorData?.interval}</span>
                                </div>
                                <p className="text-sm text-muted-foreground mb-4">
                                    Next billing date: {moment(state?.creatorData?.current_period_end).format("MMM DD, YYYY")}
                                </p>
                                <div className="flex gap-2">
                                    {
                                        state?.creatorData?.status === "active" ?
                                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 flex-1 text-sm py-2"
                                                disabled={state?.buttonLoading}
                                                onClick={() => { handleCancelPlan(state?.creatorData?.subscription_id) }}
                                            >
                                                {state?.buttonLoading ? "Cancelling..." : "Cancel Plan"}
                                            </button>
                                            : state?.creatorData?.status === "cancelled" ?
                                                <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 flex-1 text-sm py-2"
                                                    onClick={() => { handleResumePlan(state?.creatorData?.subscription_id) }}
                                                    disabled={state?.buttonLoading}
                                                >
                                                    {state?.buttonLoading ? "Resuming..." : " Resume Plan"}
                                                </button> : null
                                    }

                                </div>
                            </div>
                            <div
                                className="bg-card rounded-2xl p-4 border border-border shadow-md mb-6"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <p className="text-xs text-muted-foreground mb-3">Payment Method</p>
                                <div className="flex items-center gap-3">
                                    <div className="bg-[#f4e1e8] rounded-lg p-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#2c2124b3"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-credit-card w-5 h-5 text-foreground/70"
                                        >
                                            <rect width={20} height={14} x={2} y={5} rx={2} />
                                            <line x1={2} x2={22} y1={10} y2={10} />
                                        </svg>
                                    </div>

                                    <div className="flex-1">
                                        <p className="font-medium text-foreground">•••• •••• •••• {state?.creatorData?.payment_method?.last4}</p>
                                        <p className="text-xs text-muted-foreground">Expires {state?.creatorData?.payment_method?.exp_month}/{state?.creatorData?.payment_method?.exp_year}</p>
                                    </div>
                                    <button className="text-primary text-sm font-medium"
                                        onClick={() => handleChangePaymentMethod(state?.creatorData?.subscription_id)}
                                    >{state?.updatePaymentLoading ? "Loading..." : "Update"}</button>
                                </div>
                            </div>
                            <div className="mb-6">
                                <h2 className="font-semibold text-foreground mb-4">Payment History</h2>
                                <div className="space-y-3">
                                    {
                                        state?.inVoiceLoading ?
                                            <span>Loading Invoices ....</span>
                                            :
                                            state?.inVoiceList?.length == 0 ?
                                                (
                                                    <p className="text-muted-foreground text-sm">No Payment History</p>
                                                ) :
                                                state.inVoiceList && state.inVoiceList?.map((item, index) => (
                                                    <div
                                                        className="bg-card rounded-xl p-4 border border-border flex items-center gap-4"
                                                        style={{ opacity: 1, transform: "none" }}
                                                        key={item?.id}
                                                    >
                                                        <div className="bg-[#2dd27233] rounded-full p-2">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="#2dd272"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-circle-check-big w-4 h-4 text-success"
                                                            >
                                                                <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                                                                <path d="m9 11 3 3L22 4" />
                                                            </svg>
                                                        </div>
                                                        <div className="flex-1">
                                                            <div className="flex justify-between items-start">
                                                                <div>
                                                                    <p className="font-medium text-foreground text-sm">
                                                                        {item?.plan_name ?? "Unknown Plan"}
                                                                    </p>
                                                                    <p className="text-xs text-muted-foreground">{moment(item?.created).format("MMM DD, YYYY")}</p>
                                                                </div>
                                                                <p className="font-semibold text-foreground">${Number(item?.amount_paid / 100).toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                        <button className="text-primary hover:text-primary/80 transition-colors"
                                                            onClick={() => handleOpenPdf(item?.invoice_pdf)}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-download w-4 h-4"
                                                            >
                                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                                <polyline points="7 10 12 15 17 10" />
                                                                <line x1={12} x2={12} y1={15} y2={3} />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                ))
                                    }
                                </div>
                            </div>
                            <p className="text-xs text-center text-muted-foreground">
                                Questions about billing?{" "}
                                <button className="text-primary underline"
                                    onClick={() => navigator('/user/help')}
                                >Contact Support</button>
                            </p>
                        </div>
                }
            </div>

            {/* end: billing-history page */}

        </>
    );
}

